<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{"num_cand":"U2FsdGVkX1/6uJoie5GjyMb5dmHQsMZARvwOU1SdYoo=","cpf":"U2FsdGVkX1+MGTTdmkvkalguFSkl6CLmleZ6K89Lu2Y="},{"num_cand":"U2FsdGVkX199j9P2gYxsKvyZktNBz+0EJhfUZeetdxA=","cpf":"U2FsdGVkX1+UUbTz2K9Yerz+eVxClTmW/ZiVNxF3GAo="},{"num_cand":"U2FsdGVkX18CG+f0dCepawLvZ5A/zsjOL5BdfH0fdLw=","cpf":"U2FsdGVkX18nH4ReWChvaF3i2v2wC9Nety6j0UfN9Is="},{"num_cand":"U2FsdGVkX19gfHcvehySh21W2magbiWvyp1d+dA+TE8=","cpf":"U2FsdGVkX1/Q+diC/N/byG32l0alTvTd1WTsOD89OSI="},{"num_cand":"U2FsdGVkX1+b0zmxefBIkcl5bPDVkepo0mKOMEgoGZE=","cpf":"U2FsdGVkX194OSdNs1hymsXfoJdp7nkVqlWaZfUWyxI="},{"num_cand":"U2FsdGVkX1/3bcfzOwcr1DLSeslel/77chPe1jQZIGw=","cpf":"U2FsdGVkX1+RZ1fZQoc9MZXIeip74whN8fzX94vxot0="},{"num_cand":"U2FsdGVkX1+Whkmbfpn5GA4rAoiAFGBZhpBk5Ktg8UE=","cpf":"U2FsdGVkX19jjEyl34oFW2ta0g8wsKyGGs9DCM8kek8="},{"num_cand":"U2FsdGVkX19kEv/J155F5oN7MqIlXZCZ42IJOT0Ujto=","cpf":"U2FsdGVkX1+Rse1JsaNpxWYFr+C9WjVzagh1EaIiE6s="},{"num_cand":"U2FsdGVkX194QthP9HZz0KuE0uFNna2bX31suUKsRks=","cpf":"U2FsdGVkX1/9hIeHPGVsAuGQjOWf8QEEvZudDj6xhek="},{"num_cand":"U2FsdGVkX19d3XdQR/IgbhF578HvwnSsX390QUGeZuU=","cpf":"U2FsdGVkX18sVBxbeENFfTMITUP8c/0sw65W9M+/LNs="},{"num_cand":"U2FsdGVkX19NzxvdT5Kp49HGmgEmuDBNFdbZiEmOhKE=","cpf":"U2FsdGVkX18RtX0ccFx5JsHQ9ob8wU0pnfX9fByVLHw="},{"num_cand":"U2FsdGVkX195m3B84DgjF7YICWomOrONS8bqM0LxLIk=","cpf":"U2FsdGVkX19rHpQhCuTCT/Zjoy//cpNGGDl78cAU6EY="},{"num_cand":"U2FsdGVkX191bYRGWjijsvS3IPpRC0EVwwQ9nBJ/Tbw=","cpf":"U2FsdGVkX1+hDd6qaAyAdYmQaoK9BZq8BKovFHURxW4="},{"num_cand":"U2FsdGVkX1/ozHoDbnHyhB+JT4bQPH/i7Lujtl56Wx0=","cpf":"U2FsdGVkX1+JpvDbU7vYKsoAUlkKGUxv5u8ZZc13pzE="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2212/rec_po/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
